import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** In-dialog "We couldn't open this …" state with Try again (the dialog's own close button closes it). */
export function CrmDialogLoadError({
  subject,
  isRetrying,
  onRetry,
}: {
  subject: string;
  isRetrying: boolean;
  onRetry: () => void;
}) {
  return (
    <div className="py-10 text-center" data-testid="crm-dialog-error">
      <p className="font-medium text-gray-900">We couldn't open this {subject}</p>
      <p className="mt-1 text-sm text-gray-500">It may have been removed, or something went wrong.</p>
      <Button className="mt-4" variant="outline" disabled={isRetrying} onClick={onRetry}>
        <RefreshCw className={cn("mr-2 h-4 w-4", isRetrying && "animate-spin")} />
        Try again
      </Button>
    </div>
  );
}
